import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../components/forms';
import { usaStates, usTimezones } from '../../../utils/consts';
import { StepProps } from '../Register';

export const LocationForm = ({ touched, errors }: StepProps) => {
  return (
    <>
      <FormStepHeader title="Location" />

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="address"
      >
        <FormLabel required>Address</FormLabel>
        <Field
          name="address"
          type="text"
          as={Form.Control}
          isInvalid={touched.address && !!errors.address}
          aria-required
        />
        <ErrorMessage name="address">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="address2"
      >
        <FormLabel>Address 2</FormLabel>
        <Field
          name="address2"
          type="text"
          as={Form.Control}
          isInvalid={touched.address2 && !!errors.address2}
        />
        <ErrorMessage name="address2">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="city"
      >
        <FormLabel required>City</FormLabel>
        <Field
          name="city"
          type="text"
          as={Form.Control}
          isInvalid={touched.city && !!errors.city}
          aria-required
        />
        <ErrorMessage name="city">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>

      <Row>
        <Col
          xs={9}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="state"
          >
            <FormLabel required>State</FormLabel>
            <Field
              name="state"
              as={Form.Select}
              placeholder="Select"
              isInvalid={touched.state && !!errors.state}
              aria-required
            >
              <option>Select</option>
              {usaStates.map((state) => (
                <option
                  value={state}
                  key={state}
                >
                  {state}
                </option>
              ))}
            </Field>
            <ErrorMessage name="state">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
        <Col
          xs={3}
          className="ps-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="zip"
          >
            <FormLabel required>ZIP</FormLabel>
            <Field
              name="zip"
              type="text"
              as={Form.Control}
              isInvalid={touched.zip && !!errors.zip}
              aria-required
            />
            <ErrorMessage name="zip">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="timezone"
      >
        <FormLabel required>Preferred Time Zone</FormLabel>
        <Field
          name="timezone"
          as={Form.Select}
          options={['2', '3']}
          placeholder="Select"
          isInvalid={touched.timezone && !!errors.timezone}
          aria-required
        >
          <option>Select</option>
          {usTimezones.map((tz) => (
            <option
              value={tz}
              key={tz}
            >
              {tz}
            </option>
          ))}
        </Field>
        <ErrorMessage name="timezone">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>
    </>
  );
};
